import { t } from "i18next";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Navbar from "../../Component/NavbarTop";
import Sidebar from "../../Component/Sidebar";
import { data } from "../Dashboard/Data";
import "./CourseCreation.css";

function CourseCreation() {
  const { clrs } = useSelector((state) => state.createClr);

  return (
    <div className="section" style={{ backgroundColor: "#e5e5e5" }}>
      <Navbar page={t("LMSCourseBuilder")} />
      <div className="createcourse-main">
        <Sidebar page={"LMSCourseBuilder"} hidepage={true} />
        <div className="admin-overdue">
          <div className="admin-overdue-top">
            <div className="admin-overdue-top-item">Internal Training LMS</div>
          </div>
          <div className="admin-overdue-mid">
            <div className="admin-overdue-mid-left">
              <div className="admin-overdue-mid-left-txt"> Course Name</div>
              <div
                className="admin-overdue-mid-left-input"
                style={{ fontWeight: "400", marginLeft: "1vw" }}
              >
                UI UX
              </div>
            </div>
            <div className="admin-overdue-mid-right">
              <div className="admin-overdue-mid-left-txt">
                Training Provider
              </div>

              <div
                className="admin-overdue-mid-left-input-right"
                style={{ fontWeight: "400", marginLeft: "1vw" }}
              >
                Training Provider
              </div>
            </div>
            <div className="admin-overdue-mid-right">
              <div className="admin-overdue-mid-left-txt">Action</div>

              <div
                className="admin-overdue-mid-left-input-right"
                style={{ fontWeight: "400" }}
              >
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "3vw 3vw",
                  }}
                >
                  <svg
                    width="auto"
                    height="27"
                    viewBox="0 0 27 27"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M25.25 6.125L20.875 1.75L3.375 19.25L1.625 25.375L7.75 23.625L25.25 6.125ZM17.375 5.25L21.75 9.625L17.375 5.25ZM3.375 19.25L7.75 23.625L3.375 19.25Z"
                      stroke="#717579"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  <svg
                    width="20"
                    height="24"
                    viewBox="0 0 20 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10 1.51734e-08C10.96 -8.629e-05 11.8835 0.368002 12.5802 1.02844C13.2769 1.68888 13.6938 2.59137 13.745 3.55L13.75 3.75H19.25C19.44 3.75006 19.6229 3.82224 19.7618 3.95197C19.9006 4.0817 19.9851 4.2593 19.998 4.44888C20.011 4.63846 19.9515 4.82589 19.8316 4.9733C19.7117 5.12071 19.5402 5.2171 19.352 5.243L19.25 5.25H18.191L16.971 20.303C16.8949 21.2421 16.4681 22.1181 15.7754 22.7568C15.0828 23.3955 14.1752 23.7501 13.233 23.75H6.767C5.82484 23.7501 4.91719 23.3955 4.22457 22.7568C3.53195 22.1181 3.10513 21.2421 3.029 20.303L1.808 5.25H0.75C0.568762 5.24999 0.393658 5.18436 0.25707 5.06523C0.120481 4.94611 0.0316483 4.78155 0.00699997 4.602L0 4.5C7.6429e-06 4.31876 0.0656429 4.14366 0.184767 4.00707C0.303892 3.87048 0.468446 3.78165 0.648 3.757L0.75 3.75H6.25C6.25 2.75544 6.64509 1.80161 7.34835 1.09835C8.05161 0.395088 9.00544 1.51734e-08 10 1.51734e-08ZM16.687 5.25H3.313L4.524 20.182C4.56973 20.7454 4.82587 21.271 5.24148 21.6542C5.65709 22.0374 6.2017 22.2501 6.767 22.25H13.233C13.7983 22.2501 14.3429 22.0374 14.7585 21.6542C15.1741 21.271 15.4303 20.7454 15.476 20.182L16.686 5.25H16.687ZM7.75 9C7.93124 9.00001 8.10634 9.06564 8.24293 9.18477C8.37952 9.30389 8.46835 9.46845 8.493 9.648L8.5 9.75V17.75C8.49994 17.94 8.42776 18.1229 8.29803 18.2618C8.1683 18.4006 7.9907 18.4851 7.80112 18.498C7.61154 18.511 7.42411 18.4515 7.2767 18.3316C7.12929 18.2117 7.0329 18.0402 7.007 17.852L7 17.75V9.75C7 9.55109 7.07902 9.36032 7.21967 9.21967C7.36032 9.07902 7.55109 9 7.75 9ZM12.25 9C12.4312 9.00001 12.6063 9.06564 12.7429 9.18477C12.8795 9.30389 12.9684 9.46845 12.993 9.648L13 9.75V17.75C12.9999 17.94 12.9278 18.1229 12.798 18.2618C12.6683 18.4006 12.4907 18.4851 12.3011 18.498C12.1115 18.511 11.9241 18.4515 11.7767 18.3316C11.6293 18.2117 11.5329 18.0402 11.507 17.852L11.5 17.75V9.75C11.5 9.55109 11.579 9.36032 11.7197 9.21967C11.8603 9.07902 12.0511 9 12.25 9ZM10 1.5C9.42987 1.49993 8.88098 1.7163 8.46425 2.10537C8.04751 2.49444 7.79402 3.02721 7.755 3.596L7.75 3.75H12.25L12.245 3.596C12.206 3.02721 11.9525 2.49444 11.5358 2.10537C11.119 1.7163 10.5701 1.49993 10 1.5Z"
                      fill="#717579"
                    />
                  </svg>
                </div>
              </div>
            </div>
          </div>
          <div className="admin-overdue-bottom">
            <div className="admin-lesson">
              <div className="admin-lesson-head">Lesson</div>
              <div className="admin-lesson-body">
                <div className="admin-lesson-body-top">
                  <div className="admin-lesson-body-top-cnt">
                    <div>
                      <svg
                        width="36"
                        height="36"
                        viewBox="0 0 36 36"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M15 13.5C15.8284 13.5 16.5 12.8284 16.5 12C16.5 11.1716 15.8284 10.5 15 10.5C14.1716 10.5 13.5 11.1716 13.5 12C13.5 12.8284 14.1716 13.5 15 13.5Z"
                          fill="white"
                        />
                        <path
                          d="M15 25.5C15.8284 25.5 16.5 24.8284 16.5 24C16.5 23.1716 15.8284 22.5 15 22.5C14.1716 22.5 13.5 23.1716 13.5 24C13.5 24.8284 14.1716 25.5 15 25.5Z"
                          fill="white"
                        />
                        <path
                          d="M21 13.5C21.8284 13.5 22.5 12.8284 22.5 12C22.5 11.1716 21.8284 10.5 21 10.5C20.1716 10.5 19.5 11.1716 19.5 12C19.5 12.8284 20.1716 13.5 21 13.5Z"
                          fill="white"
                        />
                        <path
                          d="M21 25.5C21.8284 25.5 22.5 24.8284 22.5 24C22.5 23.1716 21.8284 22.5 21 22.5C20.1716 22.5 19.5 23.1716 19.5 24C19.5 24.8284 20.1716 25.5 21 25.5Z"
                          fill="white"
                        />
                        <path
                          d="M21 19.5C21.8284 19.5 22.5 18.8284 22.5 18C22.5 17.1716 21.8284 16.5 21 16.5C20.1716 16.5 19.5 17.1716 19.5 18C19.5 18.8284 20.1716 19.5 21 19.5Z"
                          fill="white"
                        />
                        <path
                          d="M15 19.5C15.8284 19.5 16.5 18.8284 16.5 18C16.5 17.1716 15.8284 16.5 15 16.5C14.1716 16.5 13.5 17.1716 13.5 18C13.5 18.8284 14.1716 19.5 15 19.5Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                    <div>Lesson 1</div>
                  </div>
                </div>
                <div className="admin-lesson-body-txt">
                  Wireframing Discription
                </div>
                <div className="admin-lesson-body-txt">
                  Lesson ID- 325461245
                </div>
                <div className="admin-lesson-body-txt">
                  Course Associated- UI UX 1246653
                </div>
                <div
                  className="admin-lesson-body-txt"
                  style={{ marginLeft: "0" }}
                >
                  <button className="admin-lesson-body-btn">Add Item</button>
                </div>
                <div
                  className="admin-lesson-body-item"
                  style={{ paddingBottom: "2vw" }}
                >
                  <div
                    className="admin-lesson-body-top"
                    style={{ backgroundColor: "#004577" }}
                  >
                    <div className="admin-lesson-body-top-cnt">
                      <div>
                        <svg
                          width="36"
                          height="36"
                          viewBox="0 0 36 36"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M15 13.5C15.8284 13.5 16.5 12.8284 16.5 12C16.5 11.1716 15.8284 10.5 15 10.5C14.1716 10.5 13.5 11.1716 13.5 12C13.5 12.8284 14.1716 13.5 15 13.5Z"
                            fill="white"
                          />
                          <path
                            d="M15 25.5C15.8284 25.5 16.5 24.8284 16.5 24C16.5 23.1716 15.8284 22.5 15 22.5C14.1716 22.5 13.5 23.1716 13.5 24C13.5 24.8284 14.1716 25.5 15 25.5Z"
                            fill="white"
                          />
                          <path
                            d="M21 13.5C21.8284 13.5 22.5 12.8284 22.5 12C22.5 11.1716 21.8284 10.5 21 10.5C20.1716 10.5 19.5 11.1716 19.5 12C19.5 12.8284 20.1716 13.5 21 13.5Z"
                            fill="white"
                          />
                          <path
                            d="M21 25.5C21.8284 25.5 22.5 24.8284 22.5 24C22.5 23.1716 21.8284 22.5 21 22.5C20.1716 22.5 19.5 23.1716 19.5 24C19.5 24.8284 20.1716 25.5 21 25.5Z"
                            fill="white"
                          />
                          <path
                            d="M21 19.5C21.8284 19.5 22.5 18.8284 22.5 18C22.5 17.1716 21.8284 16.5 21 16.5C20.1716 16.5 19.5 17.1716 19.5 18C19.5 18.8284 20.1716 19.5 21 19.5Z"
                            fill="white"
                          />
                          <path
                            d="M15 19.5C15.8284 19.5 16.5 18.8284 16.5 18C16.5 17.1716 15.8284 16.5 15 16.5C14.1716 16.5 13.5 17.1716 13.5 18C13.5 18.8284 14.1716 19.5 15 19.5Z"
                            fill="white"
                          />
                        </svg>
                      </div>
                      <div>Item 1</div>
                    </div>
                  </div>
                  <div
                    className="admin-lesson-body-item-txt"
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <div>Item ID - Video_235430</div>
                    <div>
                      {" "}
                      <div
                        className="admin-overdue-mid-left-input-right"
                        style={{ fontWeight: "400" }}
                      >
                        <div
                          style={{
                            display: "grid",
                            gridTemplateColumns: "3vw 3vw",
                          }}
                        >
                          <svg
                            width="auto"
                            height="27"
                            viewBox="0 0 27 27"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M25.25 6.125L20.875 1.75L3.375 19.25L1.625 25.375L7.75 23.625L25.25 6.125ZM17.375 5.25L21.75 9.625L17.375 5.25ZM3.375 19.25L7.75 23.625L3.375 19.25Z"
                              stroke="#717579"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                          <svg
                            width="20"
                            height="24"
                            viewBox="0 0 20 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M10 1.51734e-08C10.96 -8.629e-05 11.8835 0.368002 12.5802 1.02844C13.2769 1.68888 13.6938 2.59137 13.745 3.55L13.75 3.75H19.25C19.44 3.75006 19.6229 3.82224 19.7618 3.95197C19.9006 4.0817 19.9851 4.2593 19.998 4.44888C20.011 4.63846 19.9515 4.82589 19.8316 4.9733C19.7117 5.12071 19.5402 5.2171 19.352 5.243L19.25 5.25H18.191L16.971 20.303C16.8949 21.2421 16.4681 22.1181 15.7754 22.7568C15.0828 23.3955 14.1752 23.7501 13.233 23.75H6.767C5.82484 23.7501 4.91719 23.3955 4.22457 22.7568C3.53195 22.1181 3.10513 21.2421 3.029 20.303L1.808 5.25H0.75C0.568762 5.24999 0.393658 5.18436 0.25707 5.06523C0.120481 4.94611 0.0316483 4.78155 0.00699997 4.602L0 4.5C7.6429e-06 4.31876 0.0656429 4.14366 0.184767 4.00707C0.303892 3.87048 0.468446 3.78165 0.648 3.757L0.75 3.75H6.25C6.25 2.75544 6.64509 1.80161 7.34835 1.09835C8.05161 0.395088 9.00544 1.51734e-08 10 1.51734e-08ZM16.687 5.25H3.313L4.524 20.182C4.56973 20.7454 4.82587 21.271 5.24148 21.6542C5.65709 22.0374 6.2017 22.2501 6.767 22.25H13.233C13.7983 22.2501 14.3429 22.0374 14.7585 21.6542C15.1741 21.271 15.4303 20.7454 15.476 20.182L16.686 5.25H16.687ZM7.75 9C7.93124 9.00001 8.10634 9.06564 8.24293 9.18477C8.37952 9.30389 8.46835 9.46845 8.493 9.648L8.5 9.75V17.75C8.49994 17.94 8.42776 18.1229 8.29803 18.2618C8.1683 18.4006 7.9907 18.4851 7.80112 18.498C7.61154 18.511 7.42411 18.4515 7.2767 18.3316C7.12929 18.2117 7.0329 18.0402 7.007 17.852L7 17.75V9.75C7 9.55109 7.07902 9.36032 7.21967 9.21967C7.36032 9.07902 7.55109 9 7.75 9ZM12.25 9C12.4312 9.00001 12.6063 9.06564 12.7429 9.18477C12.8795 9.30389 12.9684 9.46845 12.993 9.648L13 9.75V17.75C12.9999 17.94 12.9278 18.1229 12.798 18.2618C12.6683 18.4006 12.4907 18.4851 12.3011 18.498C12.1115 18.511 11.9241 18.4515 11.7767 18.3316C11.6293 18.2117 11.5329 18.0402 11.507 17.852L11.5 17.75V9.75C11.5 9.55109 11.579 9.36032 11.7197 9.21967C11.8603 9.07902 12.0511 9 12.25 9ZM10 1.5C9.42987 1.49993 8.88098 1.7163 8.46425 2.10537C8.04751 2.49444 7.79402 3.02721 7.755 3.596L7.75 3.75H12.25L12.245 3.596C12.206 3.02721 11.9525 2.49444 11.5358 2.10537C11.119 1.7163 10.5701 1.49993 10 1.5Z"
                              fill="#717579"
                            />
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="admin-lesson-body-item"
                  style={{
                    margin: " 1vw 2vw",
                    padding: "1vw",
                    position: "relative",
                  }}
                >
                  <div className="admin-lesson-head">Item </div>
                  <div
                    className="admin-lesson-body-txt"
                    style={{ display: "flex" }}
                  >
                    <div
                      className="admin-lesson-body-txt"
                      style={{ marginLeft: "-2vw" }}
                    >
                      Item Name
                    </div>
                    <div className="admin-lesson-body-input">
                      <input placeholder="Item 2" />
                    </div>
                  </div>
                  <div
                    className="admin-lesson-body-txt"
                    style={{ display: "flex" }}
                  >
                    <div
                      className="admin-lesson-body-txt"
                      style={{ marginLeft: "-2vw", marginTop: "-1vw" }}
                    >
                      Type Of Item
                    </div>
                    <div className="admin-lesson-body-input">
                      <input style={{ marginLeft: "1vw" }} placeholder="PDF" />
                    </div>
                  </div>
                  <div
                    className="admin-lesson-body-txt"
                    style={{ display: "flex" }}
                  >
                    <div
                      className="admin-lesson-body-txt"
                      style={{ marginLeft: "-2vw", marginTop: "-1vw" }}
                    >
                      PDF link
                    </div>
                    <div className="admin-lesson-body-input">
                      <input style={{ marginLeft: "3.8vw" }} />
                    </div>
                  </div>
                  <div
                    className="admin-lesson-body-txt"
                    style={{ display: "flex" }}
                  >
                    <div
                      className="admin-lesson-body-txt"
                      style={{ marginLeft: "-2vw", marginTop: "-1vw" }}
                    >
                      Audio Link
                    </div>
                    <div className="admin-lesson-body-input">
                      <input style={{ marginLeft: "2.4vw" }} />
                    </div>
                  </div>
                  <button
                    className="admin-lesson-body-btn"
                    style={{ marginLeft: "60vw" }}
                  >
                    Save Item
                  </button>
                </div>
                <button className="admin-lesson-body-btn" style={{}}>
                  Add Topic
                </button>

                <div
                  className="admin-lesson"
                  style={{
                    margin: "2vw",
                    border: " 2px solid #D7D7D7",
                    borderRadius: "6px",
                  }}
                >
                  <div className="admin-lesson-body">
                    <div
                      className="admin-lesson-body-top"
                      style={{ backgroundColor: " #7783F4" }}
                    >
                      <div className="admin-lesson-body-top-cnt">
                        <div>
                          <svg
                            width="36"
                            height="36"
                            viewBox="0 0 36 36"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M15 13.5C15.8284 13.5 16.5 12.8284 16.5 12C16.5 11.1716 15.8284 10.5 15 10.5C14.1716 10.5 13.5 11.1716 13.5 12C13.5 12.8284 14.1716 13.5 15 13.5Z"
                              fill="white"
                            />
                            <path
                              d="M15 25.5C15.8284 25.5 16.5 24.8284 16.5 24C16.5 23.1716 15.8284 22.5 15 22.5C14.1716 22.5 13.5 23.1716 13.5 24C13.5 24.8284 14.1716 25.5 15 25.5Z"
                              fill="white"
                            />
                            <path
                              d="M21 13.5C21.8284 13.5 22.5 12.8284 22.5 12C22.5 11.1716 21.8284 10.5 21 10.5C20.1716 10.5 19.5 11.1716 19.5 12C19.5 12.8284 20.1716 13.5 21 13.5Z"
                              fill="white"
                            />
                            <path
                              d="M21 25.5C21.8284 25.5 22.5 24.8284 22.5 24C22.5 23.1716 21.8284 22.5 21 22.5C20.1716 22.5 19.5 23.1716 19.5 24C19.5 24.8284 20.1716 25.5 21 25.5Z"
                              fill="white"
                            />
                            <path
                              d="M21 19.5C21.8284 19.5 22.5 18.8284 22.5 18C22.5 17.1716 21.8284 16.5 21 16.5C20.1716 16.5 19.5 17.1716 19.5 18C19.5 18.8284 20.1716 19.5 21 19.5Z"
                              fill="white"
                            />
                            <path
                              d="M15 19.5C15.8284 19.5 16.5 18.8284 16.5 18C16.5 17.1716 15.8284 16.5 15 16.5C14.1716 16.5 13.5 17.1716 13.5 18C13.5 18.8284 14.1716 19.5 15 19.5Z"
                              fill="white"
                            />
                          </svg>
                        </div>
                        <div>Topic 1 </div>
                      </div>
                    </div>
                    <div className="admin-lesson-body-txt">
                      Item ID - Video_235430
                    </div>
                    <div className="admin-lesson-body-txt">
                      Associate Lesson- Lesson Name
                    </div>
                    <div className="admin-lesson-body-txt">
                      <button className="admin-lesson-body-btn">
                        Add Item
                      </button>
                    </div>
                    <div
                      className="admin-lesson-body-item"
                      style={{ paddingBottom: "2vw" }}
                    >
                      <div
                        className="admin-lesson-body-top"
                        style={{ backgroundColor: "#004577" }}
                      >
                        <div className="admin-lesson-body-top-cnt">
                          <div>
                            <svg
                              width="36"
                              height="36"
                              viewBox="0 0 36 36"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M15 13.5C15.8284 13.5 16.5 12.8284 16.5 12C16.5 11.1716 15.8284 10.5 15 10.5C14.1716 10.5 13.5 11.1716 13.5 12C13.5 12.8284 14.1716 13.5 15 13.5Z"
                                fill="white"
                              />
                              <path
                                d="M15 25.5C15.8284 25.5 16.5 24.8284 16.5 24C16.5 23.1716 15.8284 22.5 15 22.5C14.1716 22.5 13.5 23.1716 13.5 24C13.5 24.8284 14.1716 25.5 15 25.5Z"
                                fill="white"
                              />
                              <path
                                d="M21 13.5C21.8284 13.5 22.5 12.8284 22.5 12C22.5 11.1716 21.8284 10.5 21 10.5C20.1716 10.5 19.5 11.1716 19.5 12C19.5 12.8284 20.1716 13.5 21 13.5Z"
                                fill="white"
                              />
                              <path
                                d="M21 25.5C21.8284 25.5 22.5 24.8284 22.5 24C22.5 23.1716 21.8284 22.5 21 22.5C20.1716 22.5 19.5 23.1716 19.5 24C19.5 24.8284 20.1716 25.5 21 25.5Z"
                                fill="white"
                              />
                              <path
                                d="M21 19.5C21.8284 19.5 22.5 18.8284 22.5 18C22.5 17.1716 21.8284 16.5 21 16.5C20.1716 16.5 19.5 17.1716 19.5 18C19.5 18.8284 20.1716 19.5 21 19.5Z"
                                fill="white"
                              />
                              <path
                                d="M15 19.5C15.8284 19.5 16.5 18.8284 16.5 18C16.5 17.1716 15.8284 16.5 15 16.5C14.1716 16.5 13.5 17.1716 13.5 18C13.5 18.8284 14.1716 19.5 15 19.5Z"
                                fill="white"
                              />
                            </svg>
                          </div>
                          <div>Topic 1 Item</div>
                        </div>
                      </div>
                      <div
                        className="admin-lesson-body-item-txt"
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <div>Item ID - Video_235430</div>
                        <div>
                          {" "}
                          <div
                            className="admin-overdue-mid-left-input-right"
                            style={{ fontWeight: "400" }}
                          >
                            <div
                              style={{
                                display: "grid",
                                gridTemplateColumns: "3vw 3vw",
                              }}
                            >
                              <svg
                                width="auto"
                                height="27"
                                viewBox="0 0 27 27"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M25.25 6.125L20.875 1.75L3.375 19.25L1.625 25.375L7.75 23.625L25.25 6.125ZM17.375 5.25L21.75 9.625L17.375 5.25ZM3.375 19.25L7.75 23.625L3.375 19.25Z"
                                  stroke="#717579"
                                  stroke-width="2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </svg>
                              <svg
                                width="20"
                                height="24"
                                viewBox="0 0 20 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M10 1.51734e-08C10.96 -8.629e-05 11.8835 0.368002 12.5802 1.02844C13.2769 1.68888 13.6938 2.59137 13.745 3.55L13.75 3.75H19.25C19.44 3.75006 19.6229 3.82224 19.7618 3.95197C19.9006 4.0817 19.9851 4.2593 19.998 4.44888C20.011 4.63846 19.9515 4.82589 19.8316 4.9733C19.7117 5.12071 19.5402 5.2171 19.352 5.243L19.25 5.25H18.191L16.971 20.303C16.8949 21.2421 16.4681 22.1181 15.7754 22.7568C15.0828 23.3955 14.1752 23.7501 13.233 23.75H6.767C5.82484 23.7501 4.91719 23.3955 4.22457 22.7568C3.53195 22.1181 3.10513 21.2421 3.029 20.303L1.808 5.25H0.75C0.568762 5.24999 0.393658 5.18436 0.25707 5.06523C0.120481 4.94611 0.0316483 4.78155 0.00699997 4.602L0 4.5C7.6429e-06 4.31876 0.0656429 4.14366 0.184767 4.00707C0.303892 3.87048 0.468446 3.78165 0.648 3.757L0.75 3.75H6.25C6.25 2.75544 6.64509 1.80161 7.34835 1.09835C8.05161 0.395088 9.00544 1.51734e-08 10 1.51734e-08ZM16.687 5.25H3.313L4.524 20.182C4.56973 20.7454 4.82587 21.271 5.24148 21.6542C5.65709 22.0374 6.2017 22.2501 6.767 22.25H13.233C13.7983 22.2501 14.3429 22.0374 14.7585 21.6542C15.1741 21.271 15.4303 20.7454 15.476 20.182L16.686 5.25H16.687ZM7.75 9C7.93124 9.00001 8.10634 9.06564 8.24293 9.18477C8.37952 9.30389 8.46835 9.46845 8.493 9.648L8.5 9.75V17.75C8.49994 17.94 8.42776 18.1229 8.29803 18.2618C8.1683 18.4006 7.9907 18.4851 7.80112 18.498C7.61154 18.511 7.42411 18.4515 7.2767 18.3316C7.12929 18.2117 7.0329 18.0402 7.007 17.852L7 17.75V9.75C7 9.55109 7.07902 9.36032 7.21967 9.21967C7.36032 9.07902 7.55109 9 7.75 9ZM12.25 9C12.4312 9.00001 12.6063 9.06564 12.7429 9.18477C12.8795 9.30389 12.9684 9.46845 12.993 9.648L13 9.75V17.75C12.9999 17.94 12.9278 18.1229 12.798 18.2618C12.6683 18.4006 12.4907 18.4851 12.3011 18.498C12.1115 18.511 11.9241 18.4515 11.7767 18.3316C11.6293 18.2117 11.5329 18.0402 11.507 17.852L11.5 17.75V9.75C11.5 9.55109 11.579 9.36032 11.7197 9.21967C11.8603 9.07902 12.0511 9 12.25 9ZM10 1.5C9.42987 1.49993 8.88098 1.7163 8.46425 2.10537C8.04751 2.49444 7.79402 3.02721 7.755 3.596L7.75 3.75H12.25L12.245 3.596C12.206 3.02721 11.9525 2.49444 11.5358 2.10537C11.119 1.7163 10.5701 1.49993 10 1.5Z"
                                  fill="#717579"
                                />
                              </svg>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="admin-lesson-body-item"
                      style={{
                        margin: " 1vw 2vw",
                        padding: "1vw",
                        position: "relative",
                      }}
                    >
                      <div className="admin-lesson-head">Item </div>
                      <div
                        className="admin-lesson-body-txt"
                        style={{ display: "flex" }}
                      >
                        <div
                          className="admin-lesson-body-txt"
                          style={{ marginLeft: "-2vw" }}
                        >
                          Item Name
                        </div>
                        <div className="admin-lesson-body-input">
                          <input placeholder="Item 2" />
                        </div>
                      </div>
                      <div
                        className="admin-lesson-body-txt"
                        style={{ display: "flex" }}
                      >
                        <div
                          className="admin-lesson-body-txt"
                          style={{ marginLeft: "-2vw", marginTop: "-1vw" }}
                        >
                          Type Of Item
                        </div>
                        <div className="admin-lesson-body-input">
                          <input
                            style={{ marginLeft: "1vw" }}
                            placeholder="PDF"
                          />
                        </div>
                      </div>
                      <div
                        className="admin-lesson-body-txt"
                        style={{ display: "flex" }}
                      >
                        <div
                          className="admin-lesson-body-txt"
                          style={{ marginLeft: "-2vw", marginTop: "-1vw" }}
                        >
                          PDF link
                        </div>
                        <div className="admin-lesson-body-input">
                          <input style={{ marginLeft: "3.8vw" }} />
                        </div>
                      </div>
                      <div
                        className="admin-lesson-body-txt"
                        style={{ display: "flex" }}
                      >
                        <div
                          className="admin-lesson-body-txt"
                          style={{ marginLeft: "-2vw", marginTop: "-1vw" }}
                        >
                          Audio Link
                        </div>
                        <div className="admin-lesson-body-input">
                          <input style={{ marginLeft: "2.4vw" }} />
                        </div>
                      </div>
                      <button
                        className="admin-lesson-body-btn"
                        style={{ marginLeft: "60vw" }}
                      >
                        Save Item
                      </button>
                    </div>
                    <button className="admin-lesson-body-btn" style={{}}>
                      Add Topic
                    </button>
                    <div
                      className="admin-lesson"
                      style={{
                        margin: "2vw",
                        border: " 2px solid #D7D7D7",
                        borderRadius: "6px",
                      }}
                    >
                      <div className="admin-lesson-body">
                        <div
                          className="admin-lesson-body-top"
                          style={{ backgroundColor: " #2DB5B2" }}
                        >
                          <div className="admin-lesson-body-top-cnt">
                            <div>
                              <svg
                                width="36"
                                height="36"
                                viewBox="0 0 36 36"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M15 13.5C15.8284 13.5 16.5 12.8284 16.5 12C16.5 11.1716 15.8284 10.5 15 10.5C14.1716 10.5 13.5 11.1716 13.5 12C13.5 12.8284 14.1716 13.5 15 13.5Z"
                                  fill="white"
                                />
                                <path
                                  d="M15 25.5C15.8284 25.5 16.5 24.8284 16.5 24C16.5 23.1716 15.8284 22.5 15 22.5C14.1716 22.5 13.5 23.1716 13.5 24C13.5 24.8284 14.1716 25.5 15 25.5Z"
                                  fill="white"
                                />
                                <path
                                  d="M21 13.5C21.8284 13.5 22.5 12.8284 22.5 12C22.5 11.1716 21.8284 10.5 21 10.5C20.1716 10.5 19.5 11.1716 19.5 12C19.5 12.8284 20.1716 13.5 21 13.5Z"
                                  fill="white"
                                />
                                <path
                                  d="M21 25.5C21.8284 25.5 22.5 24.8284 22.5 24C22.5 23.1716 21.8284 22.5 21 22.5C20.1716 22.5 19.5 23.1716 19.5 24C19.5 24.8284 20.1716 25.5 21 25.5Z"
                                  fill="white"
                                />
                                <path
                                  d="M21 19.5C21.8284 19.5 22.5 18.8284 22.5 18C22.5 17.1716 21.8284 16.5 21 16.5C20.1716 16.5 19.5 17.1716 19.5 18C19.5 18.8284 20.1716 19.5 21 19.5Z"
                                  fill="white"
                                />
                                <path
                                  d="M15 19.5C15.8284 19.5 16.5 18.8284 16.5 18C16.5 17.1716 15.8284 16.5 15 16.5C14.1716 16.5 13.5 17.1716 13.5 18C13.5 18.8284 14.1716 19.5 15 19.5Z"
                                  fill="white"
                                />
                              </svg>
                            </div>
                            <div>Quiz 1</div>
                          </div>
                        </div>
                        <div className="admin-lesson-body-txt">Quiz 1</div>
                        <div className="admin-lesson-body-txt">
                          Associate Course-
                        </div>
                        <div
                          className="admin-lesson-body-txt"
                          style={{ marginLeft: "0" }}
                        >
                          <button className="admin-lesson-body-btn">
                            Add Question
                          </button>
                        </div>

                        <div
                          className="admin-lesson-body-item"
                          style={{
                            margin: " 1vw 2vw",
                            padding: "1vw",
                            position: "relative",
                          }}
                        >
                          <div
                            className="admin-lesson-body-txt"
                            style={{ display: "flex" }}
                          >
                            <div
                              className="admin-lesson-body-txt"
                              style={{ marginLeft: "-2vw" }}
                            >
                              Question Name
                            </div>
                            <div className="admin-lesson-body-input">
                              <input placeholder="Which Is Capital Of India ?" />
                            </div>
                          </div>
                          <div
                            className="admin-lesson-body-txt"
                            style={{ display: "flex" }}
                          >
                            <div
                              className="admin-lesson-body-txt"
                              style={{ marginLeft: "-2vw", marginTop: "-1vw" }}
                            >
                              Type Of Question
                            </div>
                            <div className="admin-lesson-body-input">
                              <input
                                style={{ marginLeft: "1.2vw" }}
                                placeholder="Choose Correct Option"
                              />
                            </div>
                          </div>
                          <div
                            className="admin-lesson-body-txt"
                            style={{ display: "flex" }}
                          >
                            <div
                              className="admin-lesson-body-txt"
                              style={{ marginLeft: "-2vw", marginTop: "-1vw" }}
                            >
                              Option 1
                            </div>
                            <div className="admin-lesson-body-input">
                              <input style={{ marginLeft: "6vw" }} />
                            </div>
                          </div>
                          <div
                            className="admin-lesson-body-txt"
                            style={{ display: "flex" }}
                          >
                            <div
                              className="admin-lesson-body-txt"
                              style={{ marginLeft: "-2vw", marginTop: "-1vw" }}
                            >
                              Option 2
                            </div>
                            <div className="admin-lesson-body-input">
                              <input style={{ marginLeft: "5.8vw" }} />
                            </div>
                          </div>
                          <div
                            className="admin-lesson-body-txt"
                            style={{ display: "flex" }}
                          >
                            <div
                              className="admin-lesson-body-txt"
                              style={{ marginLeft: "-2vw", marginTop: "-1vw" }}
                            >
                              Option 3
                            </div>
                            <div className="admin-lesson-body-input">
                              <input style={{ marginLeft: "5.8vw" }} />
                            </div>
                          </div>
                          <div
                            className="admin-lesson-body-txt"
                            style={{ display: "flex" }}
                          >
                            <div
                              className="admin-lesson-body-txt"
                              style={{ marginLeft: "-2vw", marginTop: "-1vw" }}
                            >
                              Option 4
                            </div>
                            <div className="admin-lesson-body-input">
                              <input style={{ marginLeft: "5.8vw" }} />
                            </div>
                          </div>
                          <div
                            className="admin-lesson-body-txt"
                            style={{ display: "flex" }}
                          >
                            <div
                              className="admin-lesson-body-txt"
                              style={{ marginLeft: "-2vw", marginTop: "-1vw" }}
                            >
                              Correct Answer
                            </div>
                            <div className="admin-lesson-body-input">
                              <input style={{ marginLeft: "2.2vw" }} />
                            </div>
                          </div>
                          <div
                            className="admin-lesson-body-txt"
                            style={{ display: "flex" }}
                          >
                            <div
                              className="admin-lesson-body-txt"
                              style={{ marginLeft: "-2vw", marginTop: "-1vw" }}
                            >
                              Question
                            </div>
                            <div className="admin-lesson-body-input">
                              <input style={{ marginLeft: "5.7vw" }} />
                            </div>
                          </div>
                          <div
                            className="admin-lesson-body-txt"
                            style={{ display: "flex" }}
                          >
                            <div
                              className="admin-lesson-body-txt"
                              style={{ marginLeft: "-2vw", marginTop: "-1vw" }}
                            >
                              Instructrion
                            </div>
                            <div className="admin-lesson-body-input">
                              <input style={{ marginLeft: "4.3vw" }} />
                            </div>
                          </div>
                          <button
                            className="admin-lesson-body-btn"
                            style={{ marginLeft: "60vw" }}
                          >
                            Save Item
                          </button>
                        </div>
                        <div>
                          <div
                            className="admin-lesson-body-item"
                            style={{ paddingBottom: "2vw" }}
                          >
                            <div
                              className="admin-lesson-body-top"
                              style={{ backgroundColor: "#0B2D2D" }}
                            >
                              <div className="admin-lesson-body-top-cnt">
                                <div>Which Is Captial Of India ?</div>
                              </div>
                            </div>
                            <div
                              className="admin-lesson-body-item-txt"
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              <div>Choose Correct Option</div>
                              <div>
                                {" "}
                                <div
                                  className="admin-overdue-mid-left-input-right"
                                  style={{ fontWeight: "400" }}
                                >
                                  <div
                                    style={{
                                      display: "grid",
                                      gridTemplateColumns: "3vw 3vw",
                                    }}
                                  >
                                    <svg
                                      width="auto"
                                      height="27"
                                      viewBox="0 0 27 27"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M25.25 6.125L20.875 1.75L3.375 19.25L1.625 25.375L7.75 23.625L25.25 6.125ZM17.375 5.25L21.75 9.625L17.375 5.25ZM3.375 19.25L7.75 23.625L3.375 19.25Z"
                                        stroke="#717579"
                                        stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                    </svg>
                                    <svg
                                      width="20"
                                      height="24"
                                      viewBox="0 0 20 24"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M10 1.51734e-08C10.96 -8.629e-05 11.8835 0.368002 12.5802 1.02844C13.2769 1.68888 13.6938 2.59137 13.745 3.55L13.75 3.75H19.25C19.44 3.75006 19.6229 3.82224 19.7618 3.95197C19.9006 4.0817 19.9851 4.2593 19.998 4.44888C20.011 4.63846 19.9515 4.82589 19.8316 4.9733C19.7117 5.12071 19.5402 5.2171 19.352 5.243L19.25 5.25H18.191L16.971 20.303C16.8949 21.2421 16.4681 22.1181 15.7754 22.7568C15.0828 23.3955 14.1752 23.7501 13.233 23.75H6.767C5.82484 23.7501 4.91719 23.3955 4.22457 22.7568C3.53195 22.1181 3.10513 21.2421 3.029 20.303L1.808 5.25H0.75C0.568762 5.24999 0.393658 5.18436 0.25707 5.06523C0.120481 4.94611 0.0316483 4.78155 0.00699997 4.602L0 4.5C7.6429e-06 4.31876 0.0656429 4.14366 0.184767 4.00707C0.303892 3.87048 0.468446 3.78165 0.648 3.757L0.75 3.75H6.25C6.25 2.75544 6.64509 1.80161 7.34835 1.09835C8.05161 0.395088 9.00544 1.51734e-08 10 1.51734e-08ZM16.687 5.25H3.313L4.524 20.182C4.56973 20.7454 4.82587 21.271 5.24148 21.6542C5.65709 22.0374 6.2017 22.2501 6.767 22.25H13.233C13.7983 22.2501 14.3429 22.0374 14.7585 21.6542C15.1741 21.271 15.4303 20.7454 15.476 20.182L16.686 5.25H16.687ZM7.75 9C7.93124 9.00001 8.10634 9.06564 8.24293 9.18477C8.37952 9.30389 8.46835 9.46845 8.493 9.648L8.5 9.75V17.75C8.49994 17.94 8.42776 18.1229 8.29803 18.2618C8.1683 18.4006 7.9907 18.4851 7.80112 18.498C7.61154 18.511 7.42411 18.4515 7.2767 18.3316C7.12929 18.2117 7.0329 18.0402 7.007 17.852L7 17.75V9.75C7 9.55109 7.07902 9.36032 7.21967 9.21967C7.36032 9.07902 7.55109 9 7.75 9ZM12.25 9C12.4312 9.00001 12.6063 9.06564 12.7429 9.18477C12.8795 9.30389 12.9684 9.46845 12.993 9.648L13 9.75V17.75C12.9999 17.94 12.9278 18.1229 12.798 18.2618C12.6683 18.4006 12.4907 18.4851 12.3011 18.498C12.1115 18.511 11.9241 18.4515 11.7767 18.3316C11.6293 18.2117 11.5329 18.0402 11.507 17.852L11.5 17.75V9.75C11.5 9.55109 11.579 9.36032 11.7197 9.21967C11.8603 9.07902 12.0511 9 12.25 9ZM10 1.5C9.42987 1.49993 8.88098 1.7163 8.46425 2.10537C8.04751 2.49444 7.79402 3.02721 7.755 3.596L7.75 3.75H12.25L12.245 3.596C12.206 3.02721 11.9525 2.49444 11.5358 2.10537C11.119 1.7163 10.5701 1.49993 10 1.5Z"
                                        fill="#717579"
                                      />
                                    </svg>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="admin-lesson-body-item"
                          style={{
                            margin: " 1vw 2vw",
                            padding: "1vw",
                            position: "relative",
                          }}
                        >
                          <div
                            className="admin-lesson-body-txt"
                            style={{ display: "flex" }}
                          >
                            <div
                              className="admin-lesson-body-txt"
                              style={{ marginLeft: "-2vw" }}
                            >
                              Quiz Name
                            </div>
                            <div
                              className="admin-lesson-body-input"
                              style={{ marginLeft: "6vw" }}
                            >
                              <input placeholder="Quiz 2" />
                            </div>
                          </div>
                          <div
                            className="admin-lesson-body-txt"
                            style={{ display: "flex" }}
                          >
                            <div
                              className="admin-lesson-body-txt"
                              style={{ marginLeft: "-2vw", marginTop: "-1vw" }}
                            >
                              Passing Score In %
                            </div>
                            <div className="admin-lesson-body-input">
                              <input
                                style={{ marginLeft: "4vw" }}
                                placeholder="Choose Correct Option"
                              />
                            </div>
                          </div>
                          <div
                            className="admin-lesson-body-txt"
                            style={{ display: "flex" }}
                          >
                            <div
                              className="admin-lesson-body-txt"
                              style={{ marginLeft: "-2vw", marginTop: "-1vw" }}
                            >
                              Retries Allowed
                            </div>
                            <div className="admin-lesson-body-input">
                              <input style={{ marginLeft: "5.6vw" }} />
                            </div>
                          </div>
                          <div
                            className="admin-lesson-body-txt"
                            style={{ display: "flex" }}
                          >
                            <div
                              className="admin-lesson-body-txt"
                              style={{ marginLeft: "-2vw", marginTop: "-1vw" }}
                            >
                              All Question <br></br> Required to<br></br> be
                              Answered?
                            </div>
                            <div className="admin-lesson-body-input">
                              <input style={{ marginLeft: "6vw" }} />
                            </div>
                          </div>
                          <div
                            className="admin-lesson-body-txt"
                            style={{ display: "flex" }}
                          >
                            <div
                              className="admin-lesson-body-txt"
                              style={{ marginLeft: "-2vw", marginTop: "-1vw" }}
                            >
                              Time Limit (Minutes)
                            </div>
                            <div className="admin-lesson-body-input">
                              <input style={{ marginLeft: "2.8vw" }} />
                            </div>
                          </div>
                          <div
                            className="admin-lesson-body-txt"
                            style={{ display: "flex" }}
                          >
                            <div
                              className="admin-lesson-body-txt"
                              style={{ marginLeft: "-2vw", marginTop: "-1vw" }}
                            >
                              Randomize Question
                            </div>
                            <div className="admin-lesson-body-input">
                              <input style={{ marginLeft: "2.8vw" }} />
                            </div>
                          </div>
                          <div
                            className="admin-lesson-body-txt"
                            style={{ display: "flex" }}
                          >
                            <div
                              className="admin-lesson-body-txt"
                              style={{ marginLeft: "-2vw", marginTop: "-1vw" }}
                            >
                              Skip Question
                            </div>
                            <div className="admin-lesson-body-input">
                              <input style={{ marginLeft: "6.4vw" }} />
                            </div>
                          </div>
                          <div
                            className="admin-lesson-body-txt"
                            style={{ display: "flex" }}
                          >
                            <div
                              className="admin-lesson-body-txt"
                              style={{ marginLeft: "-2vw", marginTop: "-1vw" }}
                            >
                              Randomize Answer
                            </div>
                            <div className="admin-lesson-body-input">
                              <input style={{ marginLeft: "3.7vw" }} />
                            </div>
                          </div>
                          <div
                            className="admin-lesson-body-txt"
                            style={{ display: "flex" }}
                          >
                            <div
                              className="admin-lesson-body-txt"
                              style={{ marginLeft: "-2vw", marginTop: "-1vw" }}
                            >
                              Success Message
                            </div>
                            <div className="admin-lesson-body-input">
                              <input style={{ marginLeft: "4.3vw" }} />
                            </div>
                          </div>
                          <div
                            className="admin-lesson-body-txt"
                            style={{ display: "flex" }}
                          >
                            <div
                              className="admin-lesson-body-txt"
                              style={{ marginLeft: "-2vw", marginTop: "-1vw" }}
                            >
                              Retake Message
                            </div>
                            <div className="admin-lesson-body-input">
                              <input style={{ marginLeft: "4.9vw" }} />
                            </div>
                          </div>
                          <button
                            className="admin-lesson-body-btn"
                            style={{ marginLeft: "60vw" }}
                          >
                            Save Quiz
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="admin-lesson-body-item"
                style={{
                  margin: " 1vw 2vw",
                  padding: "1vw",
                  position: "relative",
                }}
              >
                <div className="admin-lesson-head">Topic </div>
                <div
                  className="admin-lesson-body-txt"
                  style={{ display: "flex" }}
                >
                  <div
                    className="admin-lesson-body-txt"
                    style={{ marginLeft: "-2vw" }}
                  >
                    Topic Name
                  </div>
                  <div className="admin-lesson-body-input">
                    <input
                      placeholder="Topic 2"
                      style={{ marginLeft: "6vw" }}
                    />
                  </div>
                </div>
                <div
                  className="admin-lesson-body-txt"
                  style={{ display: "flex" }}
                >
                  <div
                    className="admin-lesson-body-txt"
                    style={{ marginLeft: "-2vw", marginTop: "-1vw" }}
                  >
                    Topic Document
                  </div>
                  <div className="admin-lesson-body-input">
                    <input style={{ marginLeft: "3.7vw" }} placeholder="PDF" />
                  </div>
                </div>
                <div
                  className="admin-lesson-body-txt"
                  style={{ display: "flex" }}
                >
                  <div
                    className="admin-lesson-body-txt"
                    style={{ marginLeft: "-2vw", marginTop: "-1vw" }}
                  >
                    Short Description
                  </div>
                  <div className="admin-lesson-body-input">
                    <input style={{ marginLeft: "3.2vw" }} />
                  </div>
                </div>
                <div
                  className="admin-lesson-body-txt"
                  style={{ display: "flex" }}
                >
                  <div
                    className="admin-lesson-body-txt"
                    style={{ marginLeft: "-2vw", marginTop: "-1vw" }}
                  >
                    Sample Topic
                  </div>
                  <div className="admin-lesson-body-input">
                    <input style={{ marginLeft: "5vw" }} />
                  </div>
                </div>
                <button
                  className="admin-lesson-body-btn"
                  style={{ marginLeft: "60vw" }}
                >
                  Save Topic
                </button>
              </div>
              <div
                className="admin-lesson"
                style={{
                  margin: "2vw",
                  border: " 2px solid #D7D7D7",
                  borderRadius: "6px",
                }}
              >
                <div className="admin-lesson-body">
                  <div
                    className="admin-lesson-body-top"
                    style={{ backgroundColor: " #2DB5B2" }}
                  >
                    <div className="admin-lesson-body-top-cnt">
                      <div>
                        <svg
                          width="36"
                          height="36"
                          viewBox="0 0 36 36"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M15 13.5C15.8284 13.5 16.5 12.8284 16.5 12C16.5 11.1716 15.8284 10.5 15 10.5C14.1716 10.5 13.5 11.1716 13.5 12C13.5 12.8284 14.1716 13.5 15 13.5Z"
                            fill="white"
                          />
                          <path
                            d="M15 25.5C15.8284 25.5 16.5 24.8284 16.5 24C16.5 23.1716 15.8284 22.5 15 22.5C14.1716 22.5 13.5 23.1716 13.5 24C13.5 24.8284 14.1716 25.5 15 25.5Z"
                            fill="white"
                          />
                          <path
                            d="M21 13.5C21.8284 13.5 22.5 12.8284 22.5 12C22.5 11.1716 21.8284 10.5 21 10.5C20.1716 10.5 19.5 11.1716 19.5 12C19.5 12.8284 20.1716 13.5 21 13.5Z"
                            fill="white"
                          />
                          <path
                            d="M21 25.5C21.8284 25.5 22.5 24.8284 22.5 24C22.5 23.1716 21.8284 22.5 21 22.5C20.1716 22.5 19.5 23.1716 19.5 24C19.5 24.8284 20.1716 25.5 21 25.5Z"
                            fill="white"
                          />
                          <path
                            d="M21 19.5C21.8284 19.5 22.5 18.8284 22.5 18C22.5 17.1716 21.8284 16.5 21 16.5C20.1716 16.5 19.5 17.1716 19.5 18C19.5 18.8284 20.1716 19.5 21 19.5Z"
                            fill="white"
                          />
                          <path
                            d="M15 19.5C15.8284 19.5 16.5 18.8284 16.5 18C16.5 17.1716 15.8284 16.5 15 16.5C14.1716 16.5 13.5 17.1716 13.5 18C13.5 18.8284 14.1716 19.5 15 19.5Z"
                            fill="white"
                          />
                        </svg>
                      </div>
                      <div>Lesson Quiz 1</div>
                    </div>
                  </div>
                  <div className="admin-lesson-body-txt">Lesson Quiz 1</div>
                  <div className="admin-lesson-body-txt">Associate Course-</div>
                  <div
                    className="admin-lesson-body-txt"
                    style={{ marginLeft: "0" }}
                  >
                    <button className="admin-lesson-body-btn">
                      Add Question
                    </button>
                  </div>

                  <div
                    className="admin-lesson-body-item"
                    style={{
                      margin: " 1vw 2vw",
                      padding: "1vw",
                      position: "relative",
                    }}
                  >
                    <div
                      className="admin-lesson-body-txt"
                      style={{ display: "flex" }}
                    >
                      <div
                        className="admin-lesson-body-txt"
                        style={{ marginLeft: "-2vw" }}
                      >
                        Question Name
                      </div>
                      <div className="admin-lesson-body-input">
                        <input placeholder="Which Is Capital Of India ?" />
                      </div>
                    </div>
                    <div
                      className="admin-lesson-body-txt"
                      style={{ display: "flex" }}
                    >
                      <div
                        className="admin-lesson-body-txt"
                        style={{ marginLeft: "-2vw", marginTop: "-1vw" }}
                      >
                        Type Of Question
                      </div>
                      <div className="admin-lesson-body-input">
                        <input
                          style={{ marginLeft: "1.2vw" }}
                          placeholder="Choose Correct Option"
                        />
                      </div>
                    </div>
                    <div
                      className="admin-lesson-body-txt"
                      style={{ display: "flex" }}
                    >
                      <div
                        className="admin-lesson-body-txt"
                        style={{ marginLeft: "-2vw", marginTop: "-1vw" }}
                      >
                        Option 1
                      </div>
                      <div className="admin-lesson-body-input">
                        <input style={{ marginLeft: "6vw" }} />
                      </div>
                    </div>
                    <div
                      className="admin-lesson-body-txt"
                      style={{ display: "flex" }}
                    >
                      <div
                        className="admin-lesson-body-txt"
                        style={{ marginLeft: "-2vw", marginTop: "-1vw" }}
                      >
                        Option 2
                      </div>
                      <div className="admin-lesson-body-input">
                        <input style={{ marginLeft: "5.8vw" }} />
                      </div>
                    </div>
                    <div
                      className="admin-lesson-body-txt"
                      style={{ display: "flex" }}
                    >
                      <div
                        className="admin-lesson-body-txt"
                        style={{ marginLeft: "-2vw", marginTop: "-1vw" }}
                      >
                        Option 3
                      </div>
                      <div className="admin-lesson-body-input">
                        <input style={{ marginLeft: "5.8vw" }} />
                      </div>
                    </div>
                    <div
                      className="admin-lesson-body-txt"
                      style={{ display: "flex" }}
                    >
                      <div
                        className="admin-lesson-body-txt"
                        style={{ marginLeft: "-2vw", marginTop: "-1vw" }}
                      >
                        Option 4
                      </div>
                      <div className="admin-lesson-body-input">
                        <input style={{ marginLeft: "5.8vw" }} />
                      </div>
                    </div>
                    <div
                      className="admin-lesson-body-txt"
                      style={{ display: "flex" }}
                    >
                      <div
                        className="admin-lesson-body-txt"
                        style={{ marginLeft: "-2vw", marginTop: "-1vw" }}
                      >
                        Correct Answer
                      </div>
                      <div className="admin-lesson-body-input">
                        <input style={{ marginLeft: "2.2vw" }} />
                      </div>
                    </div>
                    <div
                      className="admin-lesson-body-txt"
                      style={{ display: "flex" }}
                    >
                      <div
                        className="admin-lesson-body-txt"
                        style={{ marginLeft: "-2vw", marginTop: "-1vw" }}
                      >
                        Question
                      </div>
                      <div className="admin-lesson-body-input">
                        <input style={{ marginLeft: "5.7vw" }} />
                      </div>
                    </div>
                    <div
                      className="admin-lesson-body-txt"
                      style={{ display: "flex" }}
                    >
                      <div
                        className="admin-lesson-body-txt"
                        style={{ marginLeft: "-2vw", marginTop: "-1vw" }}
                      >
                        Instructrion
                      </div>
                      <div className="admin-lesson-body-input">
                        <input style={{ marginLeft: "4.3vw" }} />
                      </div>
                    </div>
                    <button
                      className="admin-lesson-body-btn"
                      style={{ marginLeft: "60vw" }}
                    >
                      Save Item
                    </button>
                  </div>
                  <div style={{ marginBottom: "1vw" }}>
                    <div
                      className="admin-lesson-body-item"
                      style={{ paddingBottom: "2vw" }}
                    >
                      <div
                        className="admin-lesson-body-top"
                        style={{ backgroundColor: "   #2DB5B2" }}
                      >
                        <div className="admin-lesson-body-top-cnt">
                          <div>Which Is Captial Of India ?</div>
                        </div>
                      </div>
                      <div
                        className="admin-lesson-body-item-txt"
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <div>Choose Correct Option</div>
                        <div>
                          {" "}
                          <div
                            className="admin-overdue-mid-left-input-right"
                            style={{ fontWeight: "400" }}
                          >
                            <div
                              style={{
                                display: "grid",
                                gridTemplateColumns: "3vw 3vw",
                              }}
                            >
                              <svg
                                width="auto"
                                height="27"
                                viewBox="0 0 27 27"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M25.25 6.125L20.875 1.75L3.375 19.25L1.625 25.375L7.75 23.625L25.25 6.125ZM17.375 5.25L21.75 9.625L17.375 5.25ZM3.375 19.25L7.75 23.625L3.375 19.25Z"
                                  stroke="#717579"
                                  stroke-width="2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </svg>
                              <svg
                                width="20"
                                height="24"
                                viewBox="0 0 20 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M10 1.51734e-08C10.96 -8.629e-05 11.8835 0.368002 12.5802 1.02844C13.2769 1.68888 13.6938 2.59137 13.745 3.55L13.75 3.75H19.25C19.44 3.75006 19.6229 3.82224 19.7618 3.95197C19.9006 4.0817 19.9851 4.2593 19.998 4.44888C20.011 4.63846 19.9515 4.82589 19.8316 4.9733C19.7117 5.12071 19.5402 5.2171 19.352 5.243L19.25 5.25H18.191L16.971 20.303C16.8949 21.2421 16.4681 22.1181 15.7754 22.7568C15.0828 23.3955 14.1752 23.7501 13.233 23.75H6.767C5.82484 23.7501 4.91719 23.3955 4.22457 22.7568C3.53195 22.1181 3.10513 21.2421 3.029 20.303L1.808 5.25H0.75C0.568762 5.24999 0.393658 5.18436 0.25707 5.06523C0.120481 4.94611 0.0316483 4.78155 0.00699997 4.602L0 4.5C7.6429e-06 4.31876 0.0656429 4.14366 0.184767 4.00707C0.303892 3.87048 0.468446 3.78165 0.648 3.757L0.75 3.75H6.25C6.25 2.75544 6.64509 1.80161 7.34835 1.09835C8.05161 0.395088 9.00544 1.51734e-08 10 1.51734e-08ZM16.687 5.25H3.313L4.524 20.182C4.56973 20.7454 4.82587 21.271 5.24148 21.6542C5.65709 22.0374 6.2017 22.2501 6.767 22.25H13.233C13.7983 22.2501 14.3429 22.0374 14.7585 21.6542C15.1741 21.271 15.4303 20.7454 15.476 20.182L16.686 5.25H16.687ZM7.75 9C7.93124 9.00001 8.10634 9.06564 8.24293 9.18477C8.37952 9.30389 8.46835 9.46845 8.493 9.648L8.5 9.75V17.75C8.49994 17.94 8.42776 18.1229 8.29803 18.2618C8.1683 18.4006 7.9907 18.4851 7.80112 18.498C7.61154 18.511 7.42411 18.4515 7.2767 18.3316C7.12929 18.2117 7.0329 18.0402 7.007 17.852L7 17.75V9.75C7 9.55109 7.07902 9.36032 7.21967 9.21967C7.36032 9.07902 7.55109 9 7.75 9ZM12.25 9C12.4312 9.00001 12.6063 9.06564 12.7429 9.18477C12.8795 9.30389 12.9684 9.46845 12.993 9.648L13 9.75V17.75C12.9999 17.94 12.9278 18.1229 12.798 18.2618C12.6683 18.4006 12.4907 18.4851 12.3011 18.498C12.1115 18.511 11.9241 18.4515 11.7767 18.3316C11.6293 18.2117 11.5329 18.0402 11.507 17.852L11.5 17.75V9.75C11.5 9.55109 11.579 9.36032 11.7197 9.21967C11.8603 9.07902 12.0511 9 12.25 9ZM10 1.5C9.42987 1.49993 8.88098 1.7163 8.46425 2.10537C8.04751 2.49444 7.79402 3.02721 7.755 3.596L7.75 3.75H12.25L12.245 3.596C12.206 3.02721 11.9525 2.49444 11.5358 2.10537C11.119 1.7163 10.5701 1.49993 10 1.5Z"
                                  fill="#717579"
                                />
                              </svg>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="admin-lesson-body-item"
                style={{
                  margin: " 1vw 2vw",
                  padding: "1vw",
                  position: "relative",
                }}
              >
                <div
                  className="admin-lesson-body-txt"
                  style={{ display: "flex" }}
                >
                  <div
                    className="admin-lesson-body-txt"
                    style={{ marginLeft: "-2vw" }}
                  >
                    Quiz Name
                  </div>
                  <div
                    className="admin-lesson-body-input"
                    style={{ marginLeft: "6vw" }}
                  >
                    <input placeholder="Quiz 2" />
                  </div>
                </div>
                <div
                  className="admin-lesson-body-txt"
                  style={{ display: "flex" }}
                >
                  <div
                    className="admin-lesson-body-txt"
                    style={{ marginLeft: "-2vw", marginTop: "-1vw" }}
                  >
                    Passing Score In %
                  </div>
                  <div className="admin-lesson-body-input">
                    <input
                      style={{ marginLeft: "4vw" }}
                      placeholder="Choose Correct Option"
                    />
                  </div>
                </div>
                <div
                  className="admin-lesson-body-txt"
                  style={{ display: "flex" }}
                >
                  <div
                    className="admin-lesson-body-txt"
                    style={{ marginLeft: "-2vw", marginTop: "-1vw" }}
                  >
                    Retries Allowed
                  </div>
                  <div className="admin-lesson-body-input">
                    <input style={{ marginLeft: "5.6vw" }} />
                  </div>
                </div>
                <div
                  className="admin-lesson-body-txt"
                  style={{ display: "flex" }}
                >
                  <div
                    className="admin-lesson-body-txt"
                    style={{ marginLeft: "-2vw", marginTop: "-1vw" }}
                  >
                    All Question <br></br> Required to<br></br> be Answered?
                  </div>
                  <div className="admin-lesson-body-input">
                    <input style={{ marginLeft: "6vw" }} />
                  </div>
                </div>
                <div
                  className="admin-lesson-body-txt"
                  style={{ display: "flex" }}
                >
                  <div
                    className="admin-lesson-body-txt"
                    style={{ marginLeft: "-2vw", marginTop: "-1vw" }}
                  >
                    Time Limit (Minutes)
                  </div>
                  <div className="admin-lesson-body-input">
                    <input style={{ marginLeft: "2.8vw" }} />
                  </div>
                </div>
                <div
                  className="admin-lesson-body-txt"
                  style={{ display: "flex" }}
                >
                  <div
                    className="admin-lesson-body-txt"
                    style={{ marginLeft: "-2vw", marginTop: "-1vw" }}
                  >
                    Randomize Question
                  </div>
                  <div className="admin-lesson-body-input">
                    <input style={{ marginLeft: "2.8vw" }} />
                  </div>
                </div>
                <div
                  className="admin-lesson-body-txt"
                  style={{ display: "flex" }}
                >
                  <div
                    className="admin-lesson-body-txt"
                    style={{ marginLeft: "-2vw", marginTop: "-1vw" }}
                  >
                    Skip Question
                  </div>
                  <div className="admin-lesson-body-input">
                    <input style={{ marginLeft: "6.4vw" }} />
                  </div>
                </div>
                <div
                  className="admin-lesson-body-txt"
                  style={{ display: "flex" }}
                >
                  <div
                    className="admin-lesson-body-txt"
                    style={{ marginLeft: "-2vw", marginTop: "-1vw" }}
                  >
                    Randomize Answer
                  </div>
                  <div className="admin-lesson-body-input">
                    <input style={{ marginLeft: "3.7vw" }} />
                  </div>
                </div>
                <div
                  className="admin-lesson-body-txt"
                  style={{ display: "flex" }}
                >
                  <div
                    className="admin-lesson-body-txt"
                    style={{ marginLeft: "-2vw", marginTop: "-1vw" }}
                  >
                    Success Message
                  </div>
                  <div className="admin-lesson-body-input">
                    <input style={{ marginLeft: "4.3vw" }} />
                  </div>
                </div>
                <div
                  className="admin-lesson-body-txt"
                  style={{ display: "flex" }}
                >
                  <div
                    className="admin-lesson-body-txt"
                    style={{ marginLeft: "-2vw", marginTop: "-1vw" }}
                  >
                    Retake Message
                  </div>
                  <div className="admin-lesson-body-input">
                    <input style={{ marginLeft: "4.9vw" }} />
                  </div>
                </div>
                <button
                  className="admin-lesson-body-btn"
                  style={{ marginLeft: "60vw" }}
                >
                  Save Quiz
                </button>
              </div>
            </div>
          </div>
        </div>
        <div
          style={{ height: "100%", width: "6vw", backgroundColor: "white" }}
        ></div>
        <div className="admin-overdue">
          <div className="admin-overdue-top">Final Quiz</div>
          <div className="admin-overdue-bottom">
            {" "}
            <div
              className="admin-lesson"
              style={{
                margin: "2vw",
                border: " 2px solid #D7D7D7",
                borderRadius: "6px",
              }}
            >
              <div className="admin-lesson-body">
                <div
                  className="admin-lesson-body-top"
                  style={{ backgroundColor: " #2DB5B2" }}
                >
                  <div className="admin-lesson-body-top-cnt">
                    <div>
                      <svg
                        width="36"
                        height="36"
                        viewBox="0 0 36 36"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M15 13.5C15.8284 13.5 16.5 12.8284 16.5 12C16.5 11.1716 15.8284 10.5 15 10.5C14.1716 10.5 13.5 11.1716 13.5 12C13.5 12.8284 14.1716 13.5 15 13.5Z"
                          fill="white"
                        />
                        <path
                          d="M15 25.5C15.8284 25.5 16.5 24.8284 16.5 24C16.5 23.1716 15.8284 22.5 15 22.5C14.1716 22.5 13.5 23.1716 13.5 24C13.5 24.8284 14.1716 25.5 15 25.5Z"
                          fill="white"
                        />
                        <path
                          d="M21 13.5C21.8284 13.5 22.5 12.8284 22.5 12C22.5 11.1716 21.8284 10.5 21 10.5C20.1716 10.5 19.5 11.1716 19.5 12C19.5 12.8284 20.1716 13.5 21 13.5Z"
                          fill="white"
                        />
                        <path
                          d="M21 25.5C21.8284 25.5 22.5 24.8284 22.5 24C22.5 23.1716 21.8284 22.5 21 22.5C20.1716 22.5 19.5 23.1716 19.5 24C19.5 24.8284 20.1716 25.5 21 25.5Z"
                          fill="white"
                        />
                        <path
                          d="M21 19.5C21.8284 19.5 22.5 18.8284 22.5 18C22.5 17.1716 21.8284 16.5 21 16.5C20.1716 16.5 19.5 17.1716 19.5 18C19.5 18.8284 20.1716 19.5 21 19.5Z"
                          fill="white"
                        />
                        <path
                          d="M15 19.5C15.8284 19.5 16.5 18.8284 16.5 18C16.5 17.1716 15.8284 16.5 15 16.5C14.1716 16.5 13.5 17.1716 13.5 18C13.5 18.8284 14.1716 19.5 15 19.5Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                    <div>MCQ</div>
                  </div>
                </div>
                <div className="admin-lesson-body-txt">MCQ</div>
                <div className="admin-lesson-body-txt">Associate Course-</div>
                <div
                  className="admin-lesson-body-txt"
                  style={{ marginLeft: "0" }}
                >
                  <button className="admin-lesson-body-btn">
                    Add Question
                  </button>
                </div>

                <div
                  className="admin-lesson-body-item"
                  style={{
                    margin: " 1vw 2vw",
                    padding: "1vw",
                    position: "relative",
                  }}
                >
                  <div
                    className="admin-lesson-body-txt"
                    style={{ display: "flex" }}
                  >
                    <div
                      className="admin-lesson-body-txt"
                      style={{ marginLeft: "-2vw" }}
                    >
                      Question Name
                    </div>
                    <div className="admin-lesson-body-input">
                      <input placeholder="Which Is Capital Of India ?" />
                    </div>
                  </div>
                  <div
                    className="admin-lesson-body-txt"
                    style={{ display: "flex" }}
                  >
                    <div
                      className="admin-lesson-body-txt"
                      style={{ marginLeft: "-2vw", marginTop: "-1vw" }}
                    >
                      Type Of Question
                    </div>
                    <div className="admin-lesson-body-input">
                      <input
                        style={{ marginLeft: "1.2vw" }}
                        placeholder="Choose Correct Option"
                      />
                    </div>
                  </div>
                  <div
                    className="admin-lesson-body-txt"
                    style={{ display: "flex" }}
                  >
                    <div
                      className="admin-lesson-body-txt"
                      style={{ marginLeft: "-2vw", marginTop: "-1vw" }}
                    >
                      Option 1
                    </div>
                    <div className="admin-lesson-body-input">
                      <input style={{ marginLeft: "6vw" }} />
                    </div>
                  </div>
                  <div
                    className="admin-lesson-body-txt"
                    style={{ display: "flex" }}
                  >
                    <div
                      className="admin-lesson-body-txt"
                      style={{ marginLeft: "-2vw", marginTop: "-1vw" }}
                    >
                      Option 2
                    </div>
                    <div className="admin-lesson-body-input">
                      <input style={{ marginLeft: "5.8vw" }} />
                    </div>
                  </div>
                  <div
                    className="admin-lesson-body-txt"
                    style={{ display: "flex" }}
                  >
                    <div
                      className="admin-lesson-body-txt"
                      style={{ marginLeft: "-2vw", marginTop: "-1vw" }}
                    >
                      Option 3
                    </div>
                    <div className="admin-lesson-body-input">
                      <input style={{ marginLeft: "5.8vw" }} />
                    </div>
                  </div>
                  <div
                    className="admin-lesson-body-txt"
                    style={{ display: "flex" }}
                  >
                    <div
                      className="admin-lesson-body-txt"
                      style={{ marginLeft: "-2vw", marginTop: "-1vw" }}
                    >
                      Option 4
                    </div>
                    <div className="admin-lesson-body-input">
                      <input style={{ marginLeft: "5.8vw" }} />
                    </div>
                  </div>
                  <div
                    className="admin-lesson-body-txt"
                    style={{ display: "flex" }}
                  >
                    <div
                      className="admin-lesson-body-txt"
                      style={{ marginLeft: "-2vw", marginTop: "-1vw" }}
                    >
                      Correct Answer
                    </div>
                    <div className="admin-lesson-body-input">
                      <input style={{ marginLeft: "2.2vw" }} />
                    </div>
                  </div>
                  <div
                    className="admin-lesson-body-txt"
                    style={{ display: "flex" }}
                  >
                    <div
                      className="admin-lesson-body-txt"
                      style={{ marginLeft: "-2vw", marginTop: "-1vw" }}
                    >
                      Question
                    </div>
                    <div className="admin-lesson-body-input">
                      <input style={{ marginLeft: "5.7vw" }} />
                    </div>
                  </div>
                  <div
                    className="admin-lesson-body-txt"
                    style={{ display: "flex" }}
                  >
                    <div
                      className="admin-lesson-body-txt"
                      style={{ marginLeft: "-2vw", marginTop: "-1vw" }}
                    >
                      Instructrion
                    </div>
                    <div className="admin-lesson-body-input">
                      <input style={{ marginLeft: "4.3vw" }} />
                    </div>
                  </div>
                  <button
                    className="admin-lesson-body-btn"
                    style={{ marginLeft: "60vw" }}
                  >
                    Save Item
                  </button>
                </div>
                <div style={{ marginBottom: "1vw" }}>
                  <div
                    className="admin-lesson-body-item"
                    style={{ paddingBottom: "2vw" }}
                  >
                    <div
                      className="admin-lesson-body-top"
                      style={{ backgroundColor: " #0B2D2D" }}
                    >
                      <div className="admin-lesson-body-top-cnt">
                        <div>Which Is Captial Of India ?</div>
                      </div>
                    </div>
                    <div
                      className="admin-lesson-body-item-txt"
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <div>Choose Correct Option</div>
                      <div>
                        {" "}
                        <div
                          className="admin-overdue-mid-left-input-right"
                          style={{ fontWeight: "400" }}
                        >
                          <div
                            style={{
                              display: "grid",
                              gridTemplateColumns: "3vw 3vw",
                            }}
                          >
                            <svg
                              width="auto"
                              height="27"
                              viewBox="0 0 27 27"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M25.25 6.125L20.875 1.75L3.375 19.25L1.625 25.375L7.75 23.625L25.25 6.125ZM17.375 5.25L21.75 9.625L17.375 5.25ZM3.375 19.25L7.75 23.625L3.375 19.25Z"
                                stroke="#717579"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                            <svg
                              width="20"
                              height="24"
                              viewBox="0 0 20 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M10 1.51734e-08C10.96 -8.629e-05 11.8835 0.368002 12.5802 1.02844C13.2769 1.68888 13.6938 2.59137 13.745 3.55L13.75 3.75H19.25C19.44 3.75006 19.6229 3.82224 19.7618 3.95197C19.9006 4.0817 19.9851 4.2593 19.998 4.44888C20.011 4.63846 19.9515 4.82589 19.8316 4.9733C19.7117 5.12071 19.5402 5.2171 19.352 5.243L19.25 5.25H18.191L16.971 20.303C16.8949 21.2421 16.4681 22.1181 15.7754 22.7568C15.0828 23.3955 14.1752 23.7501 13.233 23.75H6.767C5.82484 23.7501 4.91719 23.3955 4.22457 22.7568C3.53195 22.1181 3.10513 21.2421 3.029 20.303L1.808 5.25H0.75C0.568762 5.24999 0.393658 5.18436 0.25707 5.06523C0.120481 4.94611 0.0316483 4.78155 0.00699997 4.602L0 4.5C7.6429e-06 4.31876 0.0656429 4.14366 0.184767 4.00707C0.303892 3.87048 0.468446 3.78165 0.648 3.757L0.75 3.75H6.25C6.25 2.75544 6.64509 1.80161 7.34835 1.09835C8.05161 0.395088 9.00544 1.51734e-08 10 1.51734e-08ZM16.687 5.25H3.313L4.524 20.182C4.56973 20.7454 4.82587 21.271 5.24148 21.6542C5.65709 22.0374 6.2017 22.2501 6.767 22.25H13.233C13.7983 22.2501 14.3429 22.0374 14.7585 21.6542C15.1741 21.271 15.4303 20.7454 15.476 20.182L16.686 5.25H16.687ZM7.75 9C7.93124 9.00001 8.10634 9.06564 8.24293 9.18477C8.37952 9.30389 8.46835 9.46845 8.493 9.648L8.5 9.75V17.75C8.49994 17.94 8.42776 18.1229 8.29803 18.2618C8.1683 18.4006 7.9907 18.4851 7.80112 18.498C7.61154 18.511 7.42411 18.4515 7.2767 18.3316C7.12929 18.2117 7.0329 18.0402 7.007 17.852L7 17.75V9.75C7 9.55109 7.07902 9.36032 7.21967 9.21967C7.36032 9.07902 7.55109 9 7.75 9ZM12.25 9C12.4312 9.00001 12.6063 9.06564 12.7429 9.18477C12.8795 9.30389 12.9684 9.46845 12.993 9.648L13 9.75V17.75C12.9999 17.94 12.9278 18.1229 12.798 18.2618C12.6683 18.4006 12.4907 18.4851 12.3011 18.498C12.1115 18.511 11.9241 18.4515 11.7767 18.3316C11.6293 18.2117 11.5329 18.0402 11.507 17.852L11.5 17.75V9.75C11.5 9.55109 11.579 9.36032 11.7197 9.21967C11.8603 9.07902 12.0511 9 12.25 9ZM10 1.5C9.42987 1.49993 8.88098 1.7163 8.46425 2.10537C8.04751 2.49444 7.79402 3.02721 7.755 3.596L7.75 3.75H12.25L12.245 3.596C12.206 3.02721 11.9525 2.49444 11.5358 2.10537C11.119 1.7163 10.5701 1.49993 10 1.5Z"
                                fill="#717579"
                              />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="admin-lesson-body-item"
              style={{
                margin: " 1vw 2vw",
                padding: "1vw",
                position: "relative",
              }}
            >
              <div
                className="admin-lesson-body-txt"
                style={{ display: "flex" }}
              >
                <div
                  className="admin-lesson-body-txt"
                  style={{ marginLeft: "-2vw" }}
                >
                  Quiz Name
                </div>
                <div
                  className="admin-lesson-body-input"
                  style={{ marginLeft: "6vw" }}
                >
                  <input placeholder="Quiz 2" />
                </div>
              </div>
              <div
                className="admin-lesson-body-txt"
                style={{ display: "flex" }}
              >
                <div
                  className="admin-lesson-body-txt"
                  style={{ marginLeft: "-2vw", marginTop: "-1vw" }}
                >
                  Passing Score In %
                </div>
                <div className="admin-lesson-body-input">
                  <input
                    style={{ marginLeft: "4vw" }}
                    placeholder="Choose Correct Option"
                  />
                </div>
              </div>
              <div
                className="admin-lesson-body-txt"
                style={{ display: "flex" }}
              >
                <div
                  className="admin-lesson-body-txt"
                  style={{ marginLeft: "-2vw", marginTop: "-1vw" }}
                >
                  Retries Allowed
                </div>
                <div className="admin-lesson-body-input">
                  <input style={{ marginLeft: "5.6vw" }} />
                </div>
              </div>
              <div
                className="admin-lesson-body-txt"
                style={{ display: "flex" }}
              >
                <div
                  className="admin-lesson-body-txt"
                  style={{ marginLeft: "-2vw", marginTop: "-1vw" }}
                >
                  All Question <br></br> Required to<br></br> be Answered?
                </div>
                <div className="admin-lesson-body-input">
                  <input style={{ marginLeft: "6vw" }} />
                </div>
              </div>
              <div
                className="admin-lesson-body-txt"
                style={{ display: "flex" }}
              >
                <div
                  className="admin-lesson-body-txt"
                  style={{ marginLeft: "-2vw", marginTop: "-1vw" }}
                >
                  Time Limit (Minutes)
                </div>
                <div className="admin-lesson-body-input">
                  <input style={{ marginLeft: "2.8vw" }} />
                </div>
              </div>
              <div
                className="admin-lesson-body-txt"
                style={{ display: "flex" }}
              >
                <div
                  className="admin-lesson-body-txt"
                  style={{ marginLeft: "-2vw", marginTop: "-1vw" }}
                >
                  Randomize Question
                </div>
                <div className="admin-lesson-body-input">
                  <input style={{ marginLeft: "2.8vw" }} />
                </div>
              </div>
              <div
                className="admin-lesson-body-txt"
                style={{ display: "flex" }}
              >
                <div
                  className="admin-lesson-body-txt"
                  style={{ marginLeft: "-2vw", marginTop: "-1vw" }}
                >
                  Skip Question
                </div>
                <div className="admin-lesson-body-input">
                  <input style={{ marginLeft: "6.4vw" }} />
                </div>
              </div>
              <div
                className="admin-lesson-body-txt"
                style={{ display: "flex" }}
              >
                <div
                  className="admin-lesson-body-txt"
                  style={{ marginLeft: "-2vw", marginTop: "-1vw" }}
                >
                  Randomize Answer
                </div>
                <div className="admin-lesson-body-input">
                  <input style={{ marginLeft: "3.7vw" }} />
                </div>
              </div>
              <div
                className="admin-lesson-body-txt"
                style={{ display: "flex" }}
              >
                <div
                  className="admin-lesson-body-txt"
                  style={{ marginLeft: "-2vw", marginTop: "-1vw" }}
                >
                  Success Message
                </div>
                <div className="admin-lesson-body-input">
                  <input style={{ marginLeft: "4.3vw" }} />
                </div>
              </div>
              <div
                className="admin-lesson-body-txt"
                style={{ display: "flex" }}
              >
                <div
                  className="admin-lesson-body-txt"
                  style={{ marginLeft: "-2vw", marginTop: "-1vw" }}
                >
                  Retake Message
                </div>
                <div className="admin-lesson-body-input">
                  <input style={{ marginLeft: "4.9vw" }} />
                </div>
              </div>
              <button
                className="admin-lesson-body-btn"
                style={{ marginLeft: "60vw" }}
              >
                Save Quiz
              </button>
            </div>
          </div>
        </div>
        <div
          style={{ height: "100%", width: "6vw", backgroundColor: "white" }}
        ></div>
        <div className="courselist-main-cnt-back">
          <div className="courselist-main-cnt-back-btn">
            <Link to={"/admin"}>
              <button
                style={{
                  background: `${
                    clrs.CourseListBtn
                      ? clrs.CourseListBtn
                      : "hwb(224deg 78% 3%)"
                  }`,
                }}
              >
                Back
              </button>{" "}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CourseCreation;
